import type { CustomerRank } from '../hooks/useAnalyticsData';

interface Props {
  data: CustomerRank[];
  loading: boolean;
}

function formatAmount(v: number): string {
  if (v >= 10000) return `¥${(v / 10000).toFixed(1)}万`;
  return `¥${v.toLocaleString('zh-CN')}`;
}

const RANK_COLORS = ['#f59e0b', '#9ca3af', '#cd7c2f', '#0d9488', '#06b6d4', '#8b5cf6', '#ec4899', '#64748b'];

export default function TopCustomers({ data, loading }: Props) {
  const max = data[0]?.amount || 1;

  return (
    <div className="bg-white border border-gray-100 rounded-xl p-5">
      <div className="mb-5">
        <h3 className="text-sm font-semibold text-gray-800">客户消费排行</h3>
        <p className="text-xs text-gray-400 mt-0.5">按累计订单金额排名</p>
      </div>
      {loading ? (
        <div className="space-y-3">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="flex items-center gap-3 animate-pulse">
              <div className="w-6 h-6 bg-gray-100 rounded-full shrink-0" />
              <div className="flex-1 h-8 bg-gray-100 rounded-lg" />
            </div>
          ))}
        </div>
      ) : data.length === 0 ? (
        <div className="h-48 flex items-center justify-center text-sm text-gray-400">暂无数据</div>
      ) : (
        <div className="space-y-3">
          {data.map((c, i) => (
            <div key={c.id} className="flex items-center gap-3">
              {/* Rank badge */}
              <div
                className="w-6 h-6 rounded-full flex items-center justify-center text-white text-xs font-bold shrink-0"
                style={{ background: RANK_COLORS[i] || '#9ca3af' }}
              >
                {i + 1}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-sm font-medium text-gray-800 truncate">{c.name}</span>
                  <span className="text-sm font-semibold text-gray-900 ml-2 shrink-0">{formatAmount(c.amount)}</span>
                </div>
                <div className="relative h-1.5 bg-gray-100 rounded-full overflow-hidden">
                  <div
                    className="absolute inset-y-0 left-0 rounded-full transition-all duration-500"
                    style={{
                      width: `${(c.amount / max) * 100}%`,
                      background: RANK_COLORS[i] || '#9ca3af',
                    }}
                  />
                </div>
                <p className="text-xs text-gray-400 mt-0.5">{c.orders} 单</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
